import { render, staticRenderFns } from "./FamilyGroupManager.vue?vue&type=template&id=ea19fbca&scoped=true&lang=pug"
import script from "./FamilyGroupManager.vue?vue&type=script&lang=js"
export * from "./FamilyGroupManager.vue?vue&type=script&lang=js"
import style0 from "./FamilyGroupManager.vue?vue&type=style&index=0&id=ea19fbca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea19fbca",
  null
  
)

export default component.exports